export const notificationKeys = {
  notification: ['notification'] as const,
  getCounterNotifications: () => [
    ...notificationKeys.notification,
    'getCounterNotifications'
  ]
}
